export default __webpack_public_path__ + "static/media/images/V9/AnnMCMotel/V9AnnMCMotel_121.webp";